import React from 'react';

export const ViewTooltipSvg = () => (
	<svg width="320" height="161" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#a)">
			<path d="M0 0h320v161H0V0Z" fill="#F7F8F9" />
			<g clipPath="url(#b)">
				<path d="M320 0H0v230.761h320V0Z" fill="#C97CF4" />
				<mask id="c" maskUnits="userSpaceOnUse" x="0" y="0" width="320" height="231">
					<path d="M320 0H0v230.761h320V0Z" fill="#fff" />
				</mask>
				<g mask="url(#c)" strokeWidth="1.803" strokeMiterlimit="10">
					<path
						d="m36.27 60.944-4.365 98.603 335.128 166.326 4.947-111.748L36.27 60.945ZM76.568-1.634c.658-3.682 1.003-7.599 1.003-11.743 0-4.203-.347-8.171-1.017-11.9-3.982-22.198-19.398-35.884-41.018-39.408-3.69-.602-7.559-.91-11.583-.913-4.199 0-8.226.332-12.061.972-21.638 3.605-37.032 17.248-41.034 39.319-.677 3.73-1.028 7.698-1.03 11.9 0 4.143.342 8.06 1.003 11.744 3.961 22.046 19.362 35.72 41.034 39.342 3.835.64 7.86.976 12.06.976 4.026 0 7.895-.307 11.584-.904C57.167 34.236 72.604 20.534 76.57-1.634h-.002Z"
						stroke="#D8A0F7"
					/>
					<path
						d="M7.944 52.257c-27.14-4.284-59.155-14.132-83.906-30.504l-10.044 63.635c27.484 17.287 61.52 26.493 89.596 30.923 98.28 15.511 168.622-20.036 195.245-96.273L123.597 8.164C106.003 44.047 68.881 61.873 7.944 52.254v.003ZM267.923-35.671c-27.139-4.284-59.155-14.132-83.905-30.504L173.974-2.537c27.484 17.286 61.519 26.492 89.596 30.922C361.85 43.896 432.192 8.35 458.815-67.887l-75.239-11.874c-17.593 35.883-54.715 53.708-115.653 44.09Z"
						stroke="#D8A0F7"
					/>
					<path d="M219.806-18.698v141.359h61.273V-18.697h-61.273Z" stroke="#D8A0F7" />
					<path d="M219.804 18.28v-36.975h61.273v49.44" stroke="#BF63F3" />
				</g>
				<path
					d="m36.645 60.126-1.215-.554-2.612 58.999c.602.034 1.201.066 1.8.097l2.495-56.347 88.584 40.419c.665-.317 1.327-.637 1.985-.964.039-.018.077-.039.115-.059l-91.153-41.59Z"
					fill="#BF63F3"
				/>
				<path
					d="M281.979 29.819c-.6-.057-1.202-.118-1.803-.18v1.813c.601.061 1.203.118 1.803.174v-1.81.003ZM220.705 17.505c-.599-.189-1.201-.383-1.803-.577v1.896c.602.193 1.204.383 1.803.572V17.505Z"
					fill="#D8A0F7"
				/>
			</g>
			<path fill="#fff" d="M33 23.889h222.867v153.1H33z" />
			<path fill="#F7F8F9" d="M46.507 37.396h50.809v18.476H46.507z" />
			<path fill="#fff" d="M100.693 37.396h68.13v18.476h-68.13z" />
			<path
				fill="#F1F2F4"
				d="M172.2 43.257h20.261v6.754H172.2zM195.838 43.257h20.261v6.754h-20.261zM219.475 43.257h20.261v6.754h-20.261zM46.507 60.937h60.782v102.545H46.507z"
			/>
			<path d="M49.884 64.314H85.68v4.619H49.884v-4.62Z" fill="#D9D9D9" />
			<path fill="#fff" d="M49.884 72.31h54.028v27.013H49.884z" />
			<path fill="#F1F2F4" d="M54.949 77.375h47.345v2.309H54.949z" />
			<path fill="#82B536" d="M54.949 89.193h6.754v6.754h-6.754z" />
			<path fill="#fff" d="M49.884 102.701h54.028v27.014H49.884z" />
			<path fill="#F1F2F4" d="M54.949 107.766h47.345v2.309H54.949z" />
			<path fill="#82B536" d="M54.949 119.584h6.754v6.754h-6.754z" />
			<path fill="#fff" d="M49.884 133.091h54.028v27.014H49.884z" />
			<path fill="#F1F2F4" d="M54.949 138.157h47.345v2.309H54.949z" />
			<path fill="#FFA900" d="M54.949 149.975h6.754v6.754h-6.754z" />
			<path fill="#F1F2F4" d="M114.043 60.937h60.782v102.545h-60.782z" />
			<path d="M117.42 64.314h35.797v4.619H117.42v-4.62Z" fill="#D9D9D9" />
			<path fill="#fff" d="M117.42 72.31h54.028v27.013H117.42z" />
			<path fill="#F1F2F4" d="M122.485 77.375h47.345v2.309h-47.345z" />
			<path fill="#0C66E4" d="M122.485 89.193h6.754v6.754h-6.754z" />
			<path fill="#fff" d="M117.42 102.701h54.028v27.014H117.42z" />
			<path fill="#F1F2F4" d="M122.485 107.766h47.345v2.309h-47.345z" />
			<path fill="#0C66E4" d="M122.485 119.584h6.754v6.754h-6.754z" />
			<path fill="#fff" d="M117.42 133.091h54.028v27.014H117.42z" />
			<path fill="#F1F2F4" d="M122.485 138.157h47.345v2.309h-47.345z" />
			<path fill="#82B536" d="M122.485 149.975h6.754v6.754h-6.754z" />
			<path fill="#F1F2F4" d="M181.578 60.937h60.782v102.545h-60.782z" />
			<path d="M184.955 64.314h35.797v4.619h-35.797v-4.62Z" fill="#D9D9D9" />
			<path fill="#fff" d="M184.955 72.31h54.028v27.013h-54.028z" />
			<path fill="#F1F2F4" d="M190.02 77.375h47.345v2.309H190.02z" />
			<path fill="#82B536" d="M190.02 89.193h6.754v6.754h-6.754z" />
			<path fill="#F1F2F4" d="M204.723 108.09h16.884v16.884h-16.884z" />
			<path
				d="M213.798 115.899v-5.276h-1.267v5.276h-5.276v1.266h5.276v5.276h1.267v-5.276h5.276v-1.266h-5.276Z"
				fill="#F1F2F4"
			/>
			<path fill="#fff" d="M184.955 133.091h54.028v27.014h-54.028z" />
			<path fill="#F1F2F4" d="M190.02 138.157h47.345v2.309H190.02z" />
			<path fill="#0C66E4" d="M190.02 149.975h6.754v6.754h-6.754z" />
			<path
				d="M221.76 126.193c-.724-1.475-1.281-3.14-2.004-4.776l.504.277c.339.178.669.376.999.582l.261.161.275.135.561.266c.192.083.379.177.578.237.202.059.407.108.615.152.006-.113.079-.185.115-.118l-.047.131c.293-.008.539.048.78.074.238.027.458.07.68.109.22.034.439.074.666.056.229-.023.468-.082.724-.198 0 0-.119.178-.121.183 1.753-.003 3.813-.361 5.715-1.203a13.694 13.694 0 0 0 4.819-3.515h-.029l-.009-.021c-.084.036-.224.132-.391.243-.174.106-.376.233-.564.353l-.496.328c-.133.085-.221.13-.221.13.139-.305.295-.589.514-.812.212-.23.466-.419.712-.625.253-.202.528-.391.783-.597a5.46 5.46 0 0 0 .674-.696l.135.116a5.59 5.59 0 0 0-.69 1.06c.757-.668 1.795-1.829 2.502-3.192.729-1.348 1.158-2.832 1.242-3.813-.145.016-.011.675-.477.703.121-.475.202-.957.266-1.412.285.053.143.302.185.362.055-.093.154-.426.279-.94.07-.255.088-.563.134-.903.018-.172.042-.351.061-.54.011-.189.007-.385.01-.592.001-.408.015-.845-.056-1.296-.054-.45-.096-.922-.227-1.389l-.174-.708c-.056-.239-.162-.462-.242-.691-.089-.23-.173-.458-.26-.685-.094-.223-.216-.435-.326-.647-.882-1.702-2.09-3.006-2.918-3.574-.817-.601-1.139-.622-.673.259l-.171.043c.158.18.312.35.462.521.149.168.291.338.404.529.23.38.476.758.634 1.242.096.099.08.13.203.042.04.016.11.044.15-.006.287-.219.346.126.432.233-.263.119-.293.342-.193.608.094.273.272.617.514.955.061.086.121.171.187.259.054.088.109.18.159.27.112.179.217.349.312.506.208.307.324.575.341.683-.249.113-.204.316-.115.529.09.213.226.448.123.594-.023-.015-.155-.104-.18-.114-.076.074-.044.344.038.696.034.179.108.374.135.584.036.212.073.426.107.634.088.415.088.797.067 1-.024.207-.092.232-.237-.044-.101.268-.152.549-.262.834-.102.285-.197.58-.283.884-.226.596-.431 1.234-.718 1.873-.545 1.286-1.269 2.627-2.204 3.848-.932 1.218-2.074 2.308-3.302 3.089-.314.181-.612.385-.93.527-.319.143-.629.286-.938.404-.318.096-.627.182-.925.258-.299.072-.606.086-.886.114l.051.053c-.041-.008-.138.054-.183-.014-.177.186-.558.338-.89.478a6.763 6.763 0 0 1-.437.163l-.187.046-.624.181-.317.088-.322.057-.361-.036c-.222-.018-.532-.031-.861-.09a7.596 7.596 0 0 0-.513-.055c-.175-.013-.349-.018-.514-.047-.334-.04-.65-.047-.903.007-.278-.073-.532-.217-.797-.319-.261-.12-.534-.202-.777-.359-.348-.199-1.667-.799-2.578-1.262.931-.672 3.646-.932 4.14-1.744l1.35-.178c.791-.214 1.007-1.978-.23-1.601-2.156.727-5.142.706-6.949 2.574l.022.003s-.464.306-.47.234c-.199.241-.353.638-.353.638-.113 1.06.982 2.654 1.676 3.02-.248.038 2.829 5.395 3.238 3.591l.001.003Z"
				fill="#101214"
			/>
			<path fill="#fff" d="m225.817 78.054 63.459-6.2 3.039 31.106-63.46 6.199z" />
			<path
				stroke="#F0F1F2"
				strokeWidth="1.255"
				d="m225.817 78.054 63.459-6.2 3.039 31.106-63.46 6.199z"
			/>
			<path fill="#F1F2F4" d="m231.791 82.964 39.182-3.812.186 1.91-39.182 3.813z" />
			<path fill="#FFA900" d="m233.173 97.119 8.089-.79.79 8.088-8.089.79z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h320v161H0z" />
			</clipPath>
			<clipPath id="b">
				<path fill="#fff" d="M0 0h320v230.763H0z" />
			</clipPath>
		</defs>
	</svg>
);
